import React, { FC, ReactNode, createContext, useContext } from "react";

export const THEME_NAME = {
  INDEED: "INDEED"
};

const THEME_STYLE = {
  indeed: {
    primaryBlue: "#2557a7"
  }
};

interface ThemeContextProps {
  themeColor: any;
  mode: string;
}

type ThemeProviderType = {
  children?: ReactNode;
};

export const ThemeContext = createContext<ThemeContextProps>({
  mode: THEME_NAME.INDEED,
  themeColor: THEME_STYLE.indeed
});

export const useThemeContext = (): ThemeContextProps =>
  useContext(ThemeContext);

export const ThemeProvider: FC<ThemeProviderType> = ({ children }) => {
  return (
    <ThemeContext.Provider
      value={{ mode: THEME_NAME.INDEED, themeColor: THEME_STYLE.indeed }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
